module.exports = "/assets/779fc903f3b4a46c8182b5e18b3f512e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/YI.png
// module id = 3148
// module chunks = 0